import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { getECommerceBanner } from 'Store/Banners/selectors';
import BannerECommerce from 'Components/BannerECommerce/BannerECommerce';

interface IPropsInternal {
  eCommerceContent: Julius.Content.Banner;
}

class BannerECommerceContainer extends React.PureComponent<IPropsInternal> {
  render() {
    return (
      <BannerECommerce 
        eCommerceContent={ this.props.eCommerceContent }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    eCommerceContent: getECommerceBanner(state),
  };
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, null),
)(BannerECommerceContainer);


// WEBPACK FOOTER //
// ./src/components/BannerECommerce/BannerECommerceContainer.tsx